import React from "react";
import get from "lodash/get";
import DangerouslySetHtmlContent from "@stadium/ui/src/components/browser/dangerously-set-html-content";

// import "./styles/EmbededResource.module.scss";

const HtmlEmbed = ({ doc }) => {
  const { html, internal_link_id } = doc?.primary || {};
  return (
    <>
      {internal_link_id && (
        <span id={internal_link_id} className="scroll-point position-relative d-block" />
      )}
      <DangerouslySetHtmlContent
        className="bg-white html-embed-slice if-video-slice"
        html={get(html, "[0].text")}
      />
    </>
  );
};

export default HtmlEmbed;
